import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreTypes } from 'mbs-ui-shared@store/storeTypes.enum';
import { LicensesState } from './state';

const selectLicensesState = createFeatureSelector<LicensesState>(StoreTypes.Licenses);

export const selectState = createSelector(selectLicensesState, (store) => store);

export const selectPermissionFlags = createSelector(selectState, (store) => store.permissionFlags);
export const selectPermissionFlagsLoaded = createSelector(selectState, (store) => store.permissionFlagsLoaded);

export const selectBalance = createSelector(selectState, (store) => store.balance);
export const selectLoadingBalance = createSelector(selectState, (store) => store.loadingBalance);

export const selectLoading = createSelector(selectState, (store) => store.actionsInLoading > 0);

export const isInvalidLicenses = createSelector(selectState, (store) => store.isInvalidLicenses);

export const selectAssignedLicense = createSelector(selectState, (store) => store.assignedLicense);

export const selectSubscriptionEditLink = createSelector(selectState, (store) => store.subscriptionEditLink);
export const selectLoadingSubscriptionEditLink = createSelector(selectState, (store) => store.loadingSubscriptionEditLink);
